/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { BookClosedGovIcon16Light } from './BookClosedGovIcon16Light';
import { BookClosedGovIcon16Regular } from './BookClosedGovIcon16Regular';
import { BookClosedGovIcon16Solid } from './BookClosedGovIcon16Solid';
import { BookClosedGovIcon20Light } from './BookClosedGovIcon20Light';
import { BookClosedGovIcon20Regular } from './BookClosedGovIcon20Regular';
import { BookClosedGovIcon20Solid } from './BookClosedGovIcon20Solid';
import { BookClosedGovIcon24Regular } from './BookClosedGovIcon24Regular';
import { BookClosedGovIcon24Solid } from './BookClosedGovIcon24Solid';
import { BookClosedGovIcon32Regular } from './BookClosedGovIcon32Regular';
import { BookClosedGovIcon64Regular } from './BookClosedGovIcon64Regular';
var sizes = {
    16: {
        light: BookClosedGovIcon16Light,
        regular: BookClosedGovIcon16Regular,
        solid: BookClosedGovIcon16Solid,
    },
    20: {
        light: BookClosedGovIcon20Light,
        regular: BookClosedGovIcon20Regular,
        solid: BookClosedGovIcon20Solid,
    },
    24: {
        regular: BookClosedGovIcon24Regular,
        solid: BookClosedGovIcon24Solid,
    },
    32: {
        regular: BookClosedGovIcon32Regular,
    },
    64: {
        regular: BookClosedGovIcon64Regular,
    },
};
export var BookClosedGovIcon = forwardRef('BookClosedGovIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
